import axios from '../utils/axios'

export function goodthinglist(params) {//竞赛列表
  return axios.post('/Goodthing/list', params);
}



